import { Check, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const WEBSITE_FEATURES = [
  "Op til 4 standardsider",
  "Moderne design tilpasset din virksomhed",
  "100 % responsiv — mobil, tablet og desktop",
  "Kontaktformular",
  "Google Maps-integration, hvis det er relevant",
  "Grundlæggende on-page SEO-opsætning",
  "2 korrekturrunder",
  "Hjælp til lancering og tilknytning af dit domæne",
];

const MAINTENANCE_FEATURES = [
  "Løbende teknisk vedligeholdelse",
  "Sikkerhedskopier og opdateringer, hvor det er relevant",
  "Personlig support, når du har brug for det",
  "Op til 30 min. små tekst- og billedændringer pr. måned",
  "Ingen binding — opsig når som helst",
];

export const Pricing = ({ onNavigate }) => {
  const go = (href) => (e) => {
    e.preventDefault();
    onNavigate?.(href);
  };

  return (
    <section id="priser" className="py-20 sm:py-28" data-testid="pricing-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500 mb-4">
            Priser
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-zinc-900 max-w-2xl">
            Hjemmesider fra 3.995 kr.
          </h2>
          <p className="mt-4 text-base sm:text-lg text-zinc-600 max-w-2xl">
            Alle projekter får et fast tilbud før opstart.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-8 lg:grid-cols-3">
          <Reveal className="lg:col-span-2">
            <div
              data-testid="pricing-website-card"
              className="h-full bg-zinc-900 text-white rounded-2xl p-8 sm:p-10 flex flex-col"
            >
              <div className="flex flex-wrap items-baseline justify-between gap-4">
                <h3 className="text-xl sm:text-2xl font-semibold">Komplet hjemmeside</h3>
                <p className="text-3xl sm:text-4xl font-bold tracking-tight">
                  fra 3.995 kr.
                </p>
              </div>
              <p className="mt-3 text-sm text-zinc-400">
                Startpris — den endelige pris afhænger af projektets omfang. Du får
                altid et fast tilbud, før arbejdet begynder.
              </p>
              <ul className="mt-8 grid sm:grid-cols-2 gap-x-8 gap-y-3 flex-1">
                {WEBSITE_FEATURES.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm text-zinc-300">
                    <Check className="w-4 h-4 mt-0.5 text-emerald-400 shrink-0" aria-hidden="true" />
                    {f}
                  </li>
                ))}
              </ul>
              <p className="mt-8 text-xs text-zinc-500 leading-relaxed">
                Ekstra sider, webshop, avancerede bookingsystemer, specialfunktioner
                og større tekstarbejde tilbydes separat.
              </p>
              <a
                href="#kontakt"
                onClick={go("#kontakt")}
                data-testid="pricing-cta-button"
                className="mt-8 inline-flex w-fit items-center gap-2 bg-white text-zinc-900 font-medium rounded-full px-7 py-3.5 hover:bg-zinc-200 hover:-translate-y-0.5 transition-all duration-200"
              >
                Få et gratis forslag
                <ArrowRight className="w-4 h-4" aria-hidden="true" />
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.12}>
            <div
              data-testid="pricing-maintenance-card"
              className="h-full bg-white border border-zinc-200/80 rounded-2xl p-8 sm:p-10 flex flex-col hover:border-zinc-900 transition-colors duration-300"
            >
              <span className="w-fit text-[11px] font-semibold uppercase tracking-[0.15em] bg-zinc-100 text-zinc-600 rounded-full px-3 py-1.5">
                Valgfrit tillæg
              </span>
              <h3 className="mt-5 text-xl font-semibold text-zinc-900">Serviceaftale</h3>
              <p className="mt-2 text-3xl font-bold tracking-tight text-zinc-900">
                fra 499 kr.<span className="text-base font-medium text-zinc-500">/md.</span>
              </p>
              <ul className="mt-6 space-y-3 flex-1">
                {MAINTENANCE_FEATURES.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm text-zinc-600">
                    <Check className="w-4 h-4 mt-0.5 text-emerald-500 shrink-0" aria-hidden="true" />
                    {f}
                  </li>
                ))}
              </ul>
              <p className="mt-6 text-xs text-zinc-500 leading-relaxed">
                Større ændringer, nye sider, redesign og ny funktionalitet er ikke
                inkluderet og tilbydes separat.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
